"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Separator } from "@/components/ui/separator";
import { Facebook, Instagram, Twitter, Youtube, MapPin, Phone, Mail } from "lucide-react";
const services = ["Small-group motorbike journeys – Ha Giang Loop", "Easy Rider experience – 4-Day Frontier Journey", "Reserve Your Seat – Private Easy Rider", "Curated journey – Custom Expeditions"];
const contactInfo = {
  address: "Ha Giang City, Northern Vietnam",
  phone: "+84 987 654 321",
  email: "hello@frontiernorth.com"
};
const socialLinks = [{
  icon: Instagram,
  href: "https://www.instagram.com/frontiernorthadventures/",
  label: "Instagram"
}, {
  icon: Youtube,
  href: "https://www.youtube.com/frontiernorthadventures/",
  label: "YouTube"
}, {
  icon: Facebook,
  href: "https://www.facebook.com/frontiernorthadventures/",
  label: "Facebook"
}, {
  icon: Twitter,
  href: "https://twitter.com/frontiernorth/",
  label: "Twitter"
}];
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="space-y-3">
        {[1, 2, 3, 4].map((_, i) => <li key={i} data-index={i}>
            <div className="h-3 w-24 bg-muted animate-pulse rounded-none" />
          </li>)}
      </ul>;
  }
  if (!menuItems || menuItems.length === 0) {
    return <ul className="space-y-3">
        <li data-index={0}>
          <Link to="https://frontiernorthvietnam.com/" className="text-muted-foreground hover:text-foreground transition-colors duration-300 tracking-widest">
            Home
          </Link>
        </li>
        <li data-index={1}>
          <Link to="https://frontiernorthvietnam.com/the-story/" className="text-muted-foreground hover:text-foreground transition-colors duration-300 tracking-widest">
            The Story
          </Link>
        </li>
        <li data-index={2}>
          <Link to="https://frontiernorthvietnam.com/our-journeys/" className="text-muted-foreground hover:text-foreground transition-colors duration-300 tracking-widest">
            Our Journeys
          </Link>
        </li>
      </ul>;
  }
  return <ul className="space-y-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "/"} className="text-muted-foreground hover:text-foreground transition-colors duration-300 tracking-widest">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function PieDePaginaHighClass() {
  return <section data-section-id="233428" id="footer" className="bg-background text-foreground pt-16 pb-8 text-[12px] selection:bg-secondary selection:text-secondary-foreground">
      <div className="container mx-auto px-4 md:px-6 max-w-7xl">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">
          
          <div className="space-y-6">
            <Link to="https://frontiernorthvietnam.com/" className="inline-block">
              <img src="/img/frontier_north_logo_minimal.png" alt="Frontier North Adventures" className="h-7 w-auto object-contain grayscale brightness-0 dark:brightness-100" />
            </Link>
            <p className="text-muted-foreground leading-relaxed max-w-xs tracking-widest">
              Small-group motorbike journeys on the Ha Giang Loop. An Easy Rider experience defined by quiet roads and premium curation.
            </p>
          </div>

          <div className="space-y-6">
            <h4 className="font-default font-semibold text-[12px] tracking-widest uppercase text-foreground">
              Curated journey
            </h4>
            <MenuProvider menu_id="47">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          <div className="space-y-6">
            <h4 className="font-default font-semibold text-[12px] tracking-widest uppercase text-foreground">
              Small-group motorbike journeys
            </h4>
            <ul className="space-y-3">
              <li data-index={0}>
                <Link to="#" className="text-muted-foreground hover:text-foreground transition-colors duration-300 tracking-widest">3 Days Explore Journeys – Ha Giang Loop</Link>
              </li>
              <li data-index={1}>
                <Link to="#" className="text-muted-foreground hover:text-foreground transition-colors duration-300 tracking-widest">
                  Easy Rider experience – 4-Day Frontier Journey
                </Link>
              </li>
              <li data-index={2}>
                <Link to="https://frontiernorthvietnam.com/reserve-your-seat/" className="text-muted-foreground hover:text-foreground transition-colors duration-300 tracking-widest">
                  Reserve Your Seat – Private Easy Rider
                </Link>
              </li>
              <li data-index={3}>
                <Link to="#" className="text-muted-foreground hover:text-foreground transition-colors duration-300 tracking-widest">
                  Curated journey – Custom Expeditions
                </Link>
              </li>
            </ul>
          </div>

          <div className="space-y-6">
            <h4 className="font-default font-semibold text-[12px] tracking-widest uppercase text-foreground">
              Connect
            </h4>
            <ul className="space-y-4 text-muted-foreground tracking-widest">
              <li className="flex items-start gap-3 group">
                <MapPin className="size-4 text-foreground shrink-0 mt-0.5 transition-transform" />
                <span className="leading-tight">{contactInfo.address}</span>
              </li>
              <li className="flex items-center gap-3 group">
                <Phone className="size-4 text-foreground shrink-0 transition-transform" />
                <span>{contactInfo.phone}</span>
              </li>
              <li className="flex items-center gap-3 group">
                <Mail className="size-4 text-foreground shrink-0 transition-transform" />
                <span>{contactInfo.email}</span>
              </li>
            </ul>
            
            <div className="flex flex-wrap gap-3 pt-2">
              {socialLinks.map((social, i) => {
              const Icon = social.icon;
              return <Link key={i} data-index={i} to={social.href} aria-label={social.label} newTab className="bg-secondary text-secondary-foreground p-2 rounded-none hover:bg-foreground hover:text-background transition-all duration-300 shadow-none">
                    <Icon className="size-3.5" />
                  </Link>;
            })}
            </div>

            <div className="pt-4">
              <Link to="https://frontiernorthvietnam.com/reserve-your-seat/" className="inline-block bg-primary text-primary-foreground px-6 py-3 text-[10px] uppercase tracking-[0.2em] font-semibold hover:bg-primary/90 transition-colors rounded-none">
                Reserve Your Seat
              </Link>
            </div>
          </div>

        </div>

        <div className="mt-16 pt-8 border-t border-border/20 flex flex-col md:flex-row items-center justify-between gap-4 text-muted-foreground tracking-widest">
          <p className="text-center md:text-left">
            © {new Date().getFullYear()} Frontier North Adventures. Built for the Frontier.
          </p>
          <div className="flex items-center gap-4">
            <Link to="https://frontiernorthvietnam.com/privacy/" className="hover:text-foreground transition-colors">Privacy</Link>
            <span className="w-1 h-1 rounded-full bg-border" />
            <Link to="https://frontiernorthvietnam.com/terms/" className="hover:text-foreground transition-colors">Terms</Link>
          </div>
        </div>
      </div>
    </section>;
}